<app-sexual-performance
  htmlTitle="<strong>Important: Maintain</strong> Peak Sexual Performance & Confidence"
  question="We strongly recommend including ED medication in your prescription. Would you like to add it to your treatment plan?"
>
  <p class="mb-4">
    It’s common for men to experience occasional difficulty achieving or maintaining an erection while on new
    testosterone medication. Fortunately, there’s a trusted solution:
    <strong>Erectile Dysfunction Medication (Sildenafil or Tadalafil).</strong>
  </p>
  <p class="mb-4">
    By adding ED medication to your treatment plan, you can ensure more reliable erections and improved sexual
    confidence whenever you need it.
  </p>
  <p class="mb-4">
    These medications are <strong>clinically proven, safe for most men</strong>, and discreetly stored for convenient
    use.
  </p>
</app-sexual-performance>
